import axios from 'axios'

export default {
    namespaced: true,
    state: {
        building_types: [],
        construction_types: [],
        roof_types: [],
        contact_types: [],
        statuses: [],
        users: [],
        states: [],
        roles: [],
    },
    getters: {
        building_types (state) {
            return state.building_types
        },
        construction_types (state) {
            return state.construction_types
        },
        roof_types (state) {
            return state.roof_types
        },
        contact_types (state) {
            return state.contact_types
        },
        statuses (state) {
            return state.statuses
        },
        users (state) {
            return state.users
        },
        states (state) {
            return state.states
        },
        roles (state) {
            return state.roles
        }
    },
    mutations: {
        SET_BUILDING_TYPES(state, payload) {
            state.building_types = payload
        },
        SET_CONSTRUCTION_TYPES(state, payload) {
            return state.construction_types = payload
        },
        SET_ROOF_TYPES(state, payload) {
            return state.roof_types = payload
        },
        SET_CONTACT_TYPES(state, payload) {
            state.contact_types = payload
        },
        SET_STATUSES(state, payload) {
            state.statuses = payload
        },
        SET_USERS(state, payload) {
            state.users = payload
        },
        SET_STATES(state, payload) {
            state.states = payload
        },
        SET_ROLES(state, payload) {
            return state.roles = payload
        }
    },
    actions: {
        async getData({ commit }) {
            let response = await axios.get('data')
            commit('SET_BUILDING_TYPES', response.data.building_types)     
            commit('SET_CONSTRUCTION_TYPES', response.data.construction_types)
            commit('SET_ROOF_TYPES', response.data.roof_types)
            commit('SET_CONTACT_TYPES', response.data.contact_types)
            commit('SET_STATUSES', response.data.statuses)
            commit('SET_USERS', response.data.users)
            commit('SET_STATES', response.data.states)
            commit('SET_ROLES', response.data.roles)
        },
        async addUser( { dispatch }, data) {
            let response = await axios.post('user/add', data)
            await dispatch('getData')
            return response.data
        },
        async updateUser( { dispatch }, data) {
            let response = await axios.post('user/update', data)
            await dispatch('getData')
            return response.data
        },
        async addProperty( { dispatch }, data) {
            let response = await axios.post('properties', data)
            await dispatch('getData')
            return response.data
        },
        async updateProperty( { dispatch }, data) {
            let response = await axios.put('properties/' + data.id , data)
            await dispatch('getData')
            return response.data
        },
        async addPropertyComment(_, data) {
            let response = await axios.post('comments/property', data)        
            return response.data
        },
    }
}